<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="general-title">
  <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
</div>
<app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD"
  (RT)="changeMethod()"></app-return-methods>
<ng-container>
  <div class="contentBox">
    <div class="col-3">
      <div class="info-logo-container">
        <img [src]="yape_logo" class="payment_method_no_interactive red" alt="QR YAPE" />
      </div>
    </div>
    <div class="col-7">
      <div class="methodInfo">
        <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD"
          (RT)="changeMethod()"></app-return-methods>
        <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
        <ng-container *ngIf="yapeNewQrStepsFF else yapeNoQrSteps">
          <ng-container *ngIf="isMobile else isNotMobile">
            <app-counter-item [number]="1">
              <p> {{ 'yape-step-one-mobile-1' | translation | async }}
                <a [href]="yape_app_url" class="link" target="_blank" rel="noopener noreferer"> {{
                  'yape-step-one-mobile-2' | translation | async }} </a>
                {{ 'yape-step-one-mobile-3' | translation | async }}
              </p>
            </app-counter-item>
          </ng-container>

          <ng-template #isNotMobile>
            <app-counter-item [number]="1">
              <p innerHTML="{{ 'yape-step-two-qr' | translation | async }}"></p>
              <div class="yapeQrImg">
                <img [src]="yapeAppQr" alt="YAPE QR">
              </div>
            </app-counter-item>
          </ng-template>
          <app-counter-item [number]="2">
            <p innerHTML="{{ 'yape-step-three-2' | translation | async }}"></p>
            <div class="subtitle">{{ 'yape-reference-number' | translation | async }}</div>
            <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
          </app-counter-item>
          <app-counter-item [number]="3">
            <p innerHTML="{{ 'yape-step-four-2' | translation | async }}"></p>
          </app-counter-item>
        </ng-container>

        <ng-template #yapeNoQrSteps>
          <app-counter-item [number]="1">
            <p innerHTML="{{ 'yape-step-one-2' | translation | async }}"></p>
          </app-counter-item>
          <app-counter-item [number]="2">
            <p innerHTML="{{ 'yape-step-two-2' | translation | async }}"></p>
          </app-counter-item>
          <app-counter-item [number]="3">
            <p innerHTML="{{ 'yape-step-three-2' | translation | async }}"></p>
            <div class="subtitle">{{ 'yape-reference-number' | translation | async }}</div>
            <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
          </app-counter-item>
          <app-counter-item [number]="4">
            <p innerHTML="{{ 'yape-step-four-2' | translation | async }}"></p>
          </app-counter-item>
        </ng-template>

        <app-counter-item [number]="">
          <ng-container *ngIf="yapeNewQrStepsFF">
            <ng-container *ngIf="isMobile else isNotMobileMobile">
              <p innerText="{{ 'yape-link-failed-info' | translation | async  }}"></p>
            </ng-container>
            <ng-template #isNotMobileMobile>
              <p innerText="{{ 'yape-qr-failed-info' | translation | async  }}"></p>
            </ng-template>
          </ng-container>
          <p>{{ 'yape-payments-info-1' | translation | async }}
            <a [href]="yape_video_payvalida_yt" class="link" target="_blank" rel="noopener noreferer"> {{
              'yape-payments-info-here' | translation | async }} </a>
            {{ 'yape-payments-info-2' | translation | async }}
          </p>
        </app-counter-item>
      </div>
    </div>
  </div>
</ng-container>
